import styled from '@emotion/styled';
import { XIcon } from '@heroicons/react/solid';
import { useProfitDrawer } from 'src/Modules/Arbitrage/hooks';
import { ExchangeOrderbookDetailTable } from './ExchangeOrderbookDetailTable';
import { useArbitrageFilters } from 'src/Modules/Arbitrage/context';
import { Box, Drawer, Tooltip } from '@mui/material';
import { CryptoItem } from '../CryptoItem';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const DrawerArbitrageProfit = ({ open, onClose }: Props) => {
  const { activeFiltersByName, filterCatalogByName } = useArbitrageFilters();
  const { data } = useProfitDrawer();

  return (
    <Drawer anchor={'right'} open={open} onClose={onClose} variant="persistent">
      <Container>
        <CloseIcon onClick={onClose} />
        <Box p="2rem" display="flex" alignItems="center">
          <CryptoItem slug={data?.slug} symbol={data?.symbol} />
          {data?.slug && (
            <a
              href={`https://coinmarketcap.com/currencies/${data?.slug}/markets`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                borderLeft: '.5px solid white',
                marginLeft: '.5rem',
                cursor: 'pointer'
              }}
            >
              <Tooltip
                title={
                  <span>
                    {`See ${data.symbol} on `} <strong>CoinMarketCap</strong>
                  </span>
                }
                arrow
              >
                <CoinMarketCapLogo src={'/assets/coinmarketcap.png'} />
              </Tooltip>
            </a>
          )}
        </Box>
        <Box px="1rem" flex={1} overflow="hidden">
          <ExchangeOrderbookDetailTable
            data={data?.bookByExchange ?? []}
            cryptoName={data?.name ?? ''}
            cryptoSymbol={data?.symbol ?? ''}
            alertsByCompoundCryptoExchange={{}}
            isLoading={false}
            showQuoteCoinPrice={
              activeFiltersByName[filterCatalogByName.allQuoteCoins.name] !==
              undefined
            }
          />
        </Box>
      </Container>
    </Drawer>
  );
};

const Container = styled.div({
  position: 'relative',
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  '@media (min-width: 768px)': {
    width: '60vw'
  }
});

const CloseIcon = styled(XIcon)({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '2rem',
  height: '1.5rem',
  cursor: 'pointer'
});

const CoinMarketCapLogo = styled.img({
  height: '1.5rem',
  paddingLeft: '1rem'
});
